import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["append", "children", "label", "max", "status", "sx", "type"];
import React from 'react';
import MuiBadge from '@mui/material/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
export function StatusBadge(props) {
  var _props$append = props.append,
    append = _props$append === void 0 ? false : _props$append,
    children = props.children,
    label = props.label,
    _props$max = props.max,
    max = _props$max === void 0 ? 999 : _props$max,
    _props$status = props.status,
    status = _props$status === void 0 ? 'default' : _props$status,
    sx = props.sx,
    _props$type = props.type,
    type = _props$type === void 0 ? 'badge' : _props$type,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(MuiBadge, _extends({
    badgeContent: label,
    color: status === 'default' ? 'primary' : 'error',
    max: max,
    sx: _extends({
      '& .MuiBadge-dot': _extends({}, append && {
        backgroundColor: function backgroundColor(theme) {
          return status === 'default' ? theme.palette.primary[600] : theme.palette.error[600];
        },
        outline: function outline(theme) {
          return "1px solid ".concat(theme.palette.common.white);
        }
      })
    }, sx),
    variant: type === 'badge' ? 'standard' : 'dot'
  }, others, {
    "data-element": "MuiBadge",
    "data-component": "StatusBadge",
    "data-source-file": "StatusBadge.tsx",
    children: children
  }));
}